import { configureStore } from "@reduxjs/toolkit";
import { authApiSlice } from "features/api/auth/authApiSlice";
import { constantsApiSliceDev } from "features/api/constants/constantsApiSlice";
import authReducer from "features/api/auth/authSlice";
import { reportsApiSliceDev } from "features/api/reports/reportsSlice";
import { filtersSlice } from "features/api/filters/filtersSlice";
import { contentManagementApiSliceDev } from "features/api/contentManagement/contentManagementApiSlice";
import { usersPermissionsManagementApiSlice } from "features/api/usersPermissionsManagement/usersPermissionsManagementApiSlice";
import reportsSliceReducer from "./slices/reportsSlice";
import constantsSliceReducer from "./slices/constantsSlice";

export const store = configureStore({
  reducer: {
    [reportsApiSliceDev.reducerPath]: reportsApiSliceDev.reducer,
    [authApiSlice.reducerPath]: authApiSlice.reducer,
    [constantsApiSliceDev.reducerPath]: constantsApiSliceDev.reducer,
    auth: authReducer,
    reportsSliceReducer,
    constantsSlice: constantsSliceReducer,
    filters: filtersSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(reportsApiSliceDev.middleware)
      .concat(authApiSlice.middleware)
      .concat(constantsApiSliceDev.middleware)
      .concat(contentManagementApiSliceDev.middleware)
      .concat(usersPermissionsManagementApiSlice.middleware),
  // devTools:true,-    change to false on production
  devTools: true,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

export type AppStore = typeof store;

// Inferred type: {posts: PostsState, comments: CommentsState, user: UserState}
export type AppDispatch = typeof store.dispatch;
